// extracted by mini-css-extract-plugin
export default {"preview":"preview---OdKL_","label":"label---mQK6H","required":"required---gCGi1"};